import styled from "@emotion/styled";

export const NoTemplatesContainer = styled.li`
  list-style: none;
  background-color: ${({ theme }) => theme.colors.primaryColor};
  padding: 1rem;
  color: #fff;
`;
